import z from 'zod'

export let medicationSchema = z.object({
  id: z.string(),

  category: z.array(
    z.string()
      .nullable()
      .optional()
  )
    .nullable()
    .optional(),

  description: z.string()
    .nullable()
    .optional(),

  rx_code: z.string()
    .nullable()
    .optional(),

  provider_name: z.array(z.string()
    .nullable()
    .optional()
  )
    .nullable()
    .optional(),

  ndc_code: z.array(z.string()
    .nullable()
    .optional()
  )
    .nullable()
    .optional(),

  place_of_service: z.array(
    z.string()
      .nullable()
      .optional()
  )
    .nullable()
    .optional(),

  claims: z.number()
    .nullable()
    .optional(),

  first_claim_date: z.string()
    .nullable()
    .optional(),

  last_claim_date: z.string()
    .nullable()
    .optional(),

  status: z.string()
    .nullable()
    .optional()
})

export let medicationsSchema = z.array(medicationSchema)
